import React from "react";

export default function LoadingScreen() {
  return (
    <div style={styles.overlay}>
      <div style={styles.spinner} />
      <p style={styles.text}>Please wait...</p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed", inset: 0,
    background: "rgba(255,255,255,0.85)",
    display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
    zIndex: 9999,
  },
  spinner: {
    width: 48, height: 48,
    border: "4px solid #e0e0e0",
    borderTop: "4px solid #cd040b",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    marginBottom: 16,
  },
  text: { color: "#333", fontSize: 15 },
};
